import { createFileRoute } from '@tanstack/react-router';

import { PersonalStuffPageContent } from '@/components/layout/pages/personal-stuff-page';
import { staticPageHead } from '@/config/seo-head';

export const Route = createFileRoute('/personal-stuff')({
  head: () => staticPageHead('/personal-stuff'),
  component: PersonalStuffPageContent,
});
